<template>
    <div class="container container-table">
        <div class="row">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-solid box-info">
                        <div>
                            <div class="box-body">
                                <div class="row">
                                    <div style="width:224px;margin:auto;">
                                        <img src="../../src/assets/img/account/developer.png" class="center-block1">
                                    </div>
                                    <div style="test_all">
                                    <div class="text-center col-md-4 col-sm-offset-4 container">
                                        <form class="ui form loginForm container" @submit.prevent="checkCreds">
                                            <div class="input-group">
                                                <input @blur="inputBlurFn" @focus="inputfocus" :class="emailFlag || allPromptFlag || onlyEmailFlag || emailFormatFlag? input_border : ''" class="form-control input_form" ref="loginEmail" name="email" placeholder="Email" type="text" v-model="email" :onKeypress="onKeypress">
                                            </div>

                                            <div class="input-group" >
                                                <input :style="spacing" @focus="inputfocus" :class="samePasswordFlag || PasswordFlag || allPromptFlag? input_border : ''" class="form-control input_form" name="password" placeholder="Password" type="password" v-model="password" :onKeypress="onKeypress">
                                             </div>

                                             <div class="input-group" >
                                                <input :style="sameSpacing" @focus="inputfocus" :class="samePasswordFlag || allPromptFlag? input_border : ''" class="form-control input_form"  placeholder="Re-enter Password" type="password" v-model="samePassword" :onKeypress='onKeypress'>
                                             </div>
                                             <div class="input_error_response">
                                                 <p class="error_response_p" v-show="samePasswordFlag">{{samePasswordPrompt}}</p>
                                                 <p class="error_response_p" v-show="promptFlag">{{prompt}}</p>
                                                 <p class="error_response_p" v-show="emailFlag">{{emailPrompt}}</p>
                                                 <p class="error_response_p" v-show="allPromptFlag">{{allPrompt}}</p>
                                                 <p class="error_response_p" v-show="onlyEmailFlag">{{onlyEmail}}</p>
                                                 <p class="error_response_p" v-show="emailFormatFlag">{{emailFormat}}</p>
                                             </div>
                                            <div class="div_agreement">
                                                <p>{{$t('developer_account_privacy')}}</p>
                                            </div>

                                            <div :class="{ isDiv_creat_account:isSubmit === true }" class="div_creat_account" @click="creat_register_page">
                                                <span class="span_creat_account">{{$t('creat_nuwa_account')}}</span>
                                                <span class="spanCreatAccountBorder" v-show="isSubmit"></span>
                                            </div>
                                        </form>

                                        <div style="width: 37em;margin:auto;"><p class="Join-NUWA-developer">{{$t('developer_account_have_account')}}</p></div>
                                        <div class="div_signin">
                                            <button class="btn_signin" @click="login_register_page">{{$t('indexLogin')}}</button>
                                        </div>
                                    </div>
                                    <LoginFooter/>
                                    </div>
                                </div>

                                <br/>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
// import api from '../api'
// import config from '../config'
import LoginFooter from '@/views/LoginFooter.vue'
export default {
    name: 'Login',
    components: {
        LoginFooter
    },
    data (router) {
        return {
            section: 'Login',
            loading: '',
            response: '',
            spacing: '',
            sameSpacing: '',
            input_border: 'input_border',
            checkbox_flag: false,
            changeRed: false,
            focus_flag: false,
            disabled: true,
            border_style: '',
            creat_account_flag: false,
            // [fu]
            email: '',
            password: '',
            wantMessage: true,
            phone: '121111111111',
            prompt: this.$t('developer_account_password_warning'),
            samePasswordPrompt: this.$t('sameAsPassword'),
            emailPrompt: this.$t('enter_email'),
            allPrompt: this.$t('empty_mailbox'),
            onlyEmail: this.$t('duplicateEmail'),
            emailFormat: this.$t('invalidEmailFormat'),
            samePassword: '',
            samePasswordFlag: false,
            promptFlag: true,
            emailFlag: false,
            PasswordFlag: false,
            allPromptFlag: false,
            onlyEmailFlag: false,
            emailFormatFlag: false,
            onKeypress:
        'javascript:if(event.keyCode == 32)event.returnValue = false;',
            isSubmit: false
        }
    },
    methods: {
        login_register_page () {
            this.$store.state.borderStyle = 'login'
            localStorage.setItem('clickState', 'login')
            this.$router.push({ name: 'userLogin' })
        },
        reds () {
            this.changeRed = true
        },
        inputBlurFn () {
            // console.log('blur')
            this.inputBlur()
        },
        inputBlur () {
            if (!this.email) {
                return
            }
            let bodyA = { email: this.email }
            const pathA =
        '/developer/user/mail/verify'
            this._api
                .request('get', pathA, {}, bodyA)
                .then(response => {
                    if (response.status === 200) {
                        this.onlyEmailFlag = false
                    }
                })
                .catch(error => {
                    if (error.response.data.status.description === 'Duplicate mail') {
                        this.onlyEmailFlag = true
                    }
                })
        },
        creat_register_page () {
            const { email, password } = this
            this.toggleLoading()
            this.resetResponse()
            this.$store.commit('TOGGLE_LOADING')
            let body = { email, password }
            if ((!email || !password || !this.samePassword) && !this.onlyEmailFlag) {
                this.promptFlag = false
                return
            }
            if (
                this.samePasswordFlag ||
        this.PasswordFlag ||
        this.onlyEmailFlag ||
        this.emailFormatFlag
            ) {
                return
            }
            this.inputBlur()
            const path = '/developer/user/register'
            /* Making API call to authenticate a user */
            this._api
                .request('post', path, body)
                .then(response => {
                    this.toggleLoading()
                    var data = response.data.data
                    /* Checking if error object was returned from the server */
                    if (data.error) {
                        var errorName = data.error.name
                        if (errorName) {
                            this.response =
                errorName === 'InvalidCredentialsError'
                    ? 'Email/Password incorrect. Please try again.'
                    : errorName
                        } else {
                            this.response = data.error
                        }

                        return
                    }
                    localStorage.setItem('registerEmail', this.email)
                    this.$router.push({ name: 'accountAuthenticationEmail' })
                })
                .catch(error => {
                    this.$store.commit('TOGGLE_LOADING')
                    console.log(error)
                    if (
                        error.response &&
            error.response.data &&
            error.response.status >= 400
                    ) {
                        this.response = 'Please try again.'
                    } else {
                        this.response = 'Server appears to be offline'
                    }
                    this.toggleLoading()
                })
        },
        toggleLoading () {
            this.loading = this.loading === '' ? 'loading' : ''
        },
        resetResponse () {
            this.response = ''
        },
        inputfocus () {
            this.allPromptFlag = false
            this.resetResponse()
            this.focus_flag = true
            this.onlyEmailFlag = false
        },
        register_page () {
            this.$router.push({ name: 'userRegister' })
        }
    },
    // 使用生命周期函数 实现input框样式
    updated () {
        // 这是在判断 是否加密码的字间距
        if (this.password === '' || this.password === undefined) {
            this.spacing = ''
        } else {
            this.spacing = 'letter-spacing: .8em'
        }
        if (this.samePassword === '' || this.samePassword === undefined) {
            this.sameSpacing = ''
        } else {
            this.sameSpacing = 'letter-spacing: .8em'
        }
        if (this.allPromptFlag) {
            this.emailFlag = false
            this.promptFlag = false
            this.samePasswordFlag = false
            return
        }
        // 判断是否提交
        if (
            !this.samePasswordFlag &&
      !this.promptFlag &&
      !this.emailFlag &&
      !this.allPromptFlag &&
      !this.onlyEmailFlag &&
      !this.emailFormatFlag
        ) {
            // console.log(this.samePasswordFlag, this.promptFlag, this.emailFlag, this.allPromptFlag, this.onlyEmailFlag, this.emailFormatFlag)
            if (!this.isSubmit) {
                this.isSubmit = true
            }
        } else {
            // console.log(this.samePasswordFlag, this.promptFlag, this.emailFlag, this.allPromptFlag, this.onlyEmailFlag, this.emailFormatFlag)
            if (this.isSubmit) {
                this.isSubmit = false
            }
        }
        // 邮箱格式验证
        let regEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (!regEmail.test(this.email) && this.email) {
            this.emailFormatFlag = true
            this.samePasswordFlag = false
            this.emailFlag = false
            this.promptFlag = false
            this.onlyEmailFlag = false
            this.PasswordFlag = false
            return
        } else {
            this.emailFormatFlag = false
        }
        // 邮箱
        if (!this.email && (this.password || this.samePassword)) {
            this.samePasswordFlag = false
            this.emailFlag = true
            this.promptFlag = false
            this.onlyEmailFlag = false
            this.PasswordFlag = false
            return
        } else if (this.onlyEmailFlag && this.email !== '') {
            this.promptFlag = false
            this.PasswordFlag = false
            this.samePasswordFlag = false
            return
        } else {
            this.onlyEmailFlag = false
        }
        // 验证密码
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(this.password) && this.password) {
            this.emailFlag = false
            this.promptFlag = true
            this.samePasswordFlag = false
            this.PasswordFlag = true
            return
        } else {
            this.PasswordFlag = false
        }
        // 密码是否一致
        if (this.samePassword !== '' && this.samePassword !== this.password) {
            this.samePasswordFlag = true
            this.promptFlag = false
            this.emailFlag = false
        } else if (this.email && this.password && this.samePassword) {
            this.promptFlag = false
            this.samePasswordFlag = false
            this.emailFlag = false
        } else {
            this.samePasswordFlag = false
            this.promptFlag = true
            this.emailFlag = false
        }
    },
    mounted () {
        this.$store.state.isFooterShow = false
        let inviteEmail = localStorage.getItem('inviteEmail')
        if (inviteEmail) {
            this.email = inviteEmail
        }
    },
    destroyed () {
        this.$store.state.isFooterShow = true
    }
}
</script>

<style scoped>
.spanCreatAccountBorder {
  width: 406px;
  /* height: 0px; */
  height: 2px;
  background-color: rgba(51, 51, 51, 0.3);
  /* border: solid 1.2px rgba(51, 51, 51, 0.3); */
  position: absolute;
  bottom: 0px;
  left: 10px;
}
.div_agreement {
  width: 24em;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  text-align: justify;
  color: #333333;
  margin: auto;
  margin-bottom: 1em;
}
.Remember_me_image {
  width: 100%;
  height: 100%;
}
.isDiv_creat_account {
  background-color: #00b5e2 !important;
}
.div_creat_account {
  width: 430px;
  height: 78px;
  text-align: center;
  border-radius: 10px;
  background-color: rgba(51, 51, 51, 0.2);
  border: none;
  margin: auto;
  cursor: pointer;
  margin-bottom: 2.7em;
  position: relative;
}
.span_creat_account {
  width: 21.4em;
  height: 2.35em;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  text-align: center;
  color: #ffffff;
  line-height: 3.4em;
}
.error_response_p {
  margin: 0;
}
.input_error_response {
  width: 23.8em;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: rgba(246, 70, 53, 0.5);
  padding-bottom: 3.7em;
  margin: auto;
  text-align: left;
  margin-top: -0.6em;
}
.label_class {
  width: 1.7em;
  height: 1.8em;
  border: 1px solid #00b5e2;
  border-radius: 2px;
  margin-top: -0.3em;
  cursor: pointer;
}
.red {
  background-color: #00b5e2 !important;
  opacity: 1 !important;
}
.btn_signin {
  width: 10em;
  height: 2.4em;
  outline: none;
  border: 2px solid #00b5e2;
  background: white;
  color: #00b5e2;
  font-size: 22px;
  cursor: pointer;
  border-radius: 10px;
  letter-spacing: 1.2px;
  font-weight: bold;
}
.btn_login {
  width: 10em;
  height: 2.4em;
  outline: none;
  border: 0;
  border-radius: 10px;
  font-size: 22px;
  margin-bottom: 1em;
  letter-spacing: 1.2px;
  font-weight: bold;
  cursor: pointer !important;
  background-color: rgba(51, 51, 51, 0.2);
  color: #ffffff;
  opacity: 0.5;
}
.loading {
  font-size: 18px;
}
.btnStyle {
  background: #00b5e2;
  color: #ffffff;
}
.input_border {
  border-color: #f64635 !important;
  color: #f64635 !important;
}
html,
body,
.container-table {
  height: 100%;
  background-color: white !important;
}
.container-table {
  display: table;
  color: white;
  width: 72%;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.logo {
  width: 15em;
  padding: 3em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 0;
}
.input-group input {
  height: 2.7em;
}
#userLoginSubmitButton {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  height: 100%;
  outline: none;
}
/* [fu] */

/* 取消边框 */
.box.box-solid.box-info {
  border: none;
}
.center-block {
  padding-bottom: 3.5em;
}
.center-block1 {
  padding-bottom: 3.5em !important;
  margin-top: 50px;
}
.box-body {
  padding-top: 0;
}
/* input */
.input-group input {
  width: 23.8em !important;
  border-radius: 12px !important;
  border: 1px solid rgba(51, 51, 51, 0.5);
  color: #333333;
}
.input-group {
  margin: auto;
  font-weight: bold;
}
/* form剧中 */
.col-sm-offset-4 {
  margin: auto;
  width: 100%;
}
.checkbox_div {
  display: flex;
  margin-left: 2em;
  margin-bottom: 3.5em;
  width: 23.8em;
  margin: auto;
  padding-bottom: 2.8em;
  position: relative;
}
/* 这是button */
.btn-info {
  background-color: rgba(51, 51, 51, 0.2);
  border: none;
  width: 10em !important;
  margin-left: 33%;
  border-radius: 8px !important;
  font-size: 22px !important;
  height: 50px !important;
  margin-bottom: 1.5em !important;
  margin: auto;
}
.div_signin {
  width: 37em;
  padding-top: 2.7em;
  margin: auto;
}

/* input的字体大小 */
.form-control {
  padding: 6px 24px;
  font-size: 18px;
}
.Forget_password {
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #333333;
}
.Remember_me {
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 0.8px;
  color: #333333;
  padding-left: 10px;
}
.Remember_me {
  cursor: pointer;
}
.checkbox_class {
  cursor: pointer;
}
.Forget_password {
  cursor: pointer;
}
/* 加form的上下border */
.ui {
  width: 37em;
  border-bottom: 2px solid rgba(0, 224, 218, 0.3);
  border-top: 2px solid rgba(51, 51, 51, 0.1);
  padding-top: 3.4em;
}
.box {
  box-shadow: none;
  margin-bottom: 0;
}
.box-body {
  padding-bottom: 0;
}
.Join-NUWA-developer {
  width: 184px;
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: rgba(51, 51, 51, 0.5);
  margin: auto;
  padding-top: 2.6em;
  text-align: center;
}

/* 底部 */
.Copyright-2018-Nuw {
  width: 400px;
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  margin-left: 1em;
  color: #333333;
}
.copyright_a {
  color: #333333;
}
.Login-Page_Link {
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #333333;
}
.Login-Page_Link a {
  padding: 0 18px;
  color: #333333;
}
.Login-Page_Link a:not(:last-child) {
  border-right: 1px solid;
}
.input_form {
  width: 380px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: rgba(51, 51, 51, 0.3);
}
.div_footer {
  display: flex;
  clear: both;
  margin: auto;
  padding-top: 14.2em;
  width: 57em;
}
#app {
  background: rgba(0, 181, 226, 0.1);
}

/* [新增] */
.container {
  margin: auto;
}
.label_class {
  width: 21.8px;
  height: 23.2px;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.btn_signin {
  display: block;
  margin: auto;
}
.Join-NUWA-developer {
  text-align: center;
}
.input-group input {
  outline: none;
  height: 1.7em !important;
  width: 20.2em !important;
}
.checkbox_div {
  width: 20.2em !important;
}
/* 新增 */
</style>
